import "../input/recurrence-input";

import { LonaWebComponent, html } from "../../component";
import { component } from "../../component-decorators";
import { Style, css } from "../../component-styles";
import { GESTURE_MANAGER } from "../../gesture-manager";
import { Typography } from "../../ui/typography";

@component({
  name: "std-event-details-field",
})
export class EventDetailsField<
  Content extends Option<HTMLElement> = null,
> extends LonaWebComponent {
  onClickOutside: Option<() => void>;

  static makeText(label: string): EventDetailsField<HTMLParagraphElement> {
    const $e = EventDetailsField.make();
    const $label = Typography.p(label, "small");
    $e.appendChild($label);
    return $e as EventDetailsField<HTMLParagraphElement>;
  }

  static makeWith<T extends HTMLElement>(
    $child: T,
    options?: Optional<{ padding: string }>,
  ): EventDetailsField<T> {
    const $e = EventDetailsField.make();
    $e.appendChild($child);
    $e.assignStyles({
      padding: options?.padding ?? "0px",
    });
    return $e as EventDetailsField<T>;
  }

  connectedCallback() {
    GESTURE_MANAGER.setOnClickOutside(this, () => this.onClickOutside?.());
  }

  disconnectedCallback() {
    GESTURE_MANAGER.clearOnClickOutside(this);
  }

  // note: no type checking
  get $content(): Content {
    return this.children[0] as Content;
  }

  get $label(): HTMLElement {
    return this.$("label");
  }

  static $styles: Style.Compat[] = [
    css`
      :host {
        display: block;
        padding: 12px;
        border-radius: var(--border-radius, 4px);
        background: var(--bg-surface-light);
      }

      :host([first-visible]) {
        --border-radius: 10px 10px 2px 2px;
      }

      :host([last-visible]) {
        --border-radius: 2px 2px 10px 10px;
      }

      :host([first-visible][last-visible]) {
        --border-radius: 10px;
      }

      #label {
        --font-size: var(--small-size);
      }

      slot::slotted(*):focus {
        outline: none;
      }
    `,
  ];
  static $html: Option<HTMLTemplateElement> = html`
    <std-row id="root"><slot></slot></std-row>
  `;
}
